import { NotificationAlertOverride } from ".";
import { NotificationHandleType } from "../../Notifications";
import {
  createRequirementAction,
  createRequirementChildren,
  createRequirementTitle
} from "./helper";

export const RequirementsApprovedPayee: NotificationAlertOverride = (
  notification,
  history
) => {
  return {
    theme: "success",
    icon: "check-circle",
    title: createRequirementTitle(
      notification,
      NotificationHandleType.RequirementsApprovedPayee
    ),
    children: createRequirementChildren(
      notification,
      NotificationHandleType.RequirementsApprovedPayee
    ),
    action: createRequirementAction(notification, history)
  };
};
